import axios from "../utiles/axios.util";

function apiGetDspMng(item_code) {
    return axios.get(`/api/v1/dspMng?item_code=${item_code}`);
}

function apiGetDspMngDetail() {
    return axios.get(`/api/v1/dspMng/detail`);
}

function apiPostDspMng(formData) {
    return axios.post("/api/v1/dspMng", formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
}

function apiGetDspList(sdate, edate) {
    return axios.get(`/api/v1/dspMng/list?sdate=${sdate}&edate=${edate}`);
}

export { apiGetDspMng, apiGetDspMngDetail, apiPostDspMng, apiGetDspList };
